<template>
    <AppDialog :show="showUpgradeModal" closeable @close="showUpgradeModal = false">
        <template #header>
            <div class="flex lg:justify-between justify-center items-center">
                <h2 class="text-title-md font-bold tracking-tight text-gray-100">
                    {{ $t("pages_pricing_upgradePlan_title") }}
                </h2>
                <Icon
                    @click="showUpgradeModal = false"
                    class="text-gray-100 w-5 h-5 cursor-pointer !hidden lg:!block"
                    name="tabler:x"
                />
            </div>
        </template>
        <template #default>
            <div class="max-w-[500px]">
                <img src="/images/ACL-upgrade.png" class="my-6 lg:block hidden" />
                <img src="/images/ACL-upgrade-sm.png" class="my-4 block lg:hidden w-full" />
                <p class="text-body-md lg:text-body-lg text-gray-400 leading-5 lg:leading-6 lg:mb-6 mb-4">
                    {{ $t("pages_pricing_upgradePlan_desc") }}
                </p>
                <div class="flex lg:flex-row flex-col lg:justify-end lg:space-x-6">
                    <AppButton
                        class="order-2 lg:order-1"
                        :block="useDevice().isMobile ? true : false"
                        variant="ghost"
                        @click="showUpgradeModal = false"
                    >
                        {{ $t("global_later") }}
                    </AppButton>
                    <AppButton
                        class="order-1 lg:order-2"
                        :block="useDevice().isMobile ? true : false"
                        @click="navigateTo(localePath('/pricing'))"
                    >
                        {{ $t("pages_pricing_upgradeAccount") }}
                    </AppButton>
                </div>
            </div>
        </template>
    </AppDialog>
</template>

<script setup>
const showUpgradeModal = defineModel("showUpgradeModal");

const localePath = useLocalePath();
</script>
